import { Link } from "react-router-dom";
import { hotRanking, categories } from "@/mocks/animeData";

export default function RankingSection() {
  const topThree = hotRanking.slice(0, 3);

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              热门<span className="text-accent-500">排行</span>
            </h2>
            <p className="text-foreground-500 text-sm mt-3">全网热门动漫影视实时排名</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-16">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/4] lg:aspect-auto group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20anime%20scene%20with%20a%20powerful%20warrior%20character%20swinging%20a%20flaming%20sword%20in%20a%20dark%20fantasy%20world%2C%20intense%20energy%20waves%2C%20cinematic%20composition%2C%20Japanese%20anime%20art%20style%2C%20epic%20action%20moment%2C%20warm%20fiery%20tones%20against%20dark%20shadows%2C%20simple%20dark%20gradient%20background&width=800&height=1120&seq=ranking-cover-01&orientation=portrait"
                alt={topThree[0]?.title}
                title={topThree[0]?.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6">
                <span className="inline-block px-3 py-1 bg-accent-500 text-white text-xs font-bold rounded-lg mb-2 whitespace-nowrap">
                  TOP 1
                </span>
                <h3 className="text-white text-xl font-bold">{topThree[0]?.title}</h3>
                <p className="text-white/60 text-sm mt-1">
                  {topThree[0]?.category} · {topThree[0]?.views}次播放
                </p>
              </div>
              <Link
                to={`/category/all`}
                className="absolute inset-0"
                aria-label={`查看 ${topThree[0]?.title}`}
              ></Link>
            </div>

            <div className="flex flex-col gap-5">
              <div className="relative flex-1 rounded-2xl overflow-hidden group cursor-pointer min-h-[140px]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20visually%20stunning%20anime%20movie%20poster%20style%20image%20with%20rich%20colors%20and%20dramatic%20composition%2C%20featuring%20characters%20in%20dynamic%20poses%2C%20cinematic%20lighting%2C%20Japanese%20anime%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20simple%20dark%20background%20with%20soft%20gradient&width=800&height=400&seq=ranking-cover-02&orientation=landscape"
                  alt={topThree[1]?.title}
                  title={topThree[1]?.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-5 left-5">
                  <span className="inline-block px-2.5 py-0.5 bg-accent-500/90 text-white text-[10px] font-bold rounded-md mb-1.5 whitespace-nowrap">
                    TOP 2
                  </span>
                  <h3 className="text-white text-base font-semibold">{topThree[1]?.title}</h3>
                  <p className="text-white/50 text-xs mt-0.5">
                    {topThree[1]?.category} · {topThree[1]?.views}次播放
                  </p>
                </div>
                <Link
                  to="/category/all"
                  className="absolute inset-0"
                  aria-label={`查看 ${topThree[1]?.title}`}
                ></Link>
              </div>
              <div className="relative flex-1 rounded-2xl overflow-hidden group cursor-pointer min-h-[140px]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20visually%20stunning%20anime%20movie%20poster%20style%20image%20with%20rich%20colors%20and%20dramatic%20composition%2C%20featuring%20characters%20in%20dynamic%20poses%2C%20cinematic%20lighting%2C%20Japanese%20anime%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20simple%20dark%20background%20with%20soft%20gradient&width=800&height=400&seq=ranking-cover-03&orientation=landscape"
                  alt={topThree[2]?.title}
                  title={topThree[2]?.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-5 left-5">
                  <span className="inline-block px-2.5 py-0.5 bg-accent-500/90 text-white text-[10px] font-bold rounded-md mb-1.5 whitespace-nowrap">
                    TOP 3
                  </span>
                  <h3 className="text-white text-base font-semibold">{topThree[2]?.title}</h3>
                  <p className="text-white/50 text-xs mt-0.5">
                    {topThree[2]?.category} · {topThree[2]?.views}次播放
                  </p>
                </div>
                <Link
                  to="/category/all"
                  className="absolute inset-0"
                  aria-label={`查看 ${topThree[2]?.title}`}
                ></Link>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-2.5 p-5 rounded-2xl bg-background-100 hover:bg-background-200 transition-all duration-300 group cursor-pointer"
              >
                <div className="w-11 h-11 rounded-xl bg-accent-50 flex items-center justify-center group-hover:bg-accent-100 transition-colors">
                  <i className={`${cat.icon} text-accent-500 text-xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500">
                  {cat.count.toLocaleString()}部
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}